<template>
    <div class="control-box">
        <el-form ref="form" :model="form" label-width="120px">
            <el-divider content-position="left">运行环境</el-divider>
            <div class="base-info">
                <el-form-item label="计算机名：">
                    {{ env.machineName }}
                </el-form-item>
                <el-form-item label="操作系统：">
                    {{ env.osDescription }}
                </el-form-item>
                <el-form-item label="系统类型：">
                    {{ env.operatingSystem }}
                </el-form-item>
                <el-form-item label="运行时长：">
                    {{ env.tickTime }}
                </el-form-item>
            </div>
            <el-divider content-position="left">API授权</el-divider>
            <el-form-item label="终端地址：">
                <el-input
                    prefix-icon="el-icon-link"
                    v-model="form.cors.origins"
                    style="width:500px;"
                ></el-input>
                <label class="label-red">需明确指定源,多个用';'分隔</label>
            </el-form-item>
            <el-form-item label="请求方式：">
                <el-input v-model="form.cors.methods" style="width:500px;"></el-input>
                <label class="label-red">*允许所有请求方式,多个用';'分隔</label>
            </el-form-item>
            <el-form-item label="默认请求头：">
                <el-input v-model="form.cors.headers" style="width:500px;"> </el-input>
                <label class="label-red">*允许所有请求头,多个用';'分隔</label>
            </el-form-item>
            <el-form-item label="扩展请求头：">
                <el-input v-model="form.cors.exposedHeaders" style="width:500px;"> </el-input>
                <label class="label-red">需明确指定请求头,多个用';'分隔</label>
            </el-form-item>
            <el-divider content-position="left">用户设置</el-divider>
            <el-form-item label="密码更换周期：">
                <el-input-number
                    v-model="form.user.passwordLifetime"
                    :min="15"
                    :max="365"
                    controls-position="right"
                ></el-input-number>
                天
            </el-form-item>
            <el-form-item label="登录错误限制：">
                <el-input-number
                    v-model="form.user.loginErrorLimit"
                    :min="2"
                    :max="10"
                    controls-position="right"
                ></el-input-number>
                次
            </el-form-item>
            <el-form-item label="错误锁定时间：">
                <el-input-number
                    v-model="form.user.loginErrorTime"
                    :min="5"
                    controls-position="right"
                ></el-input-number>
                分钟
            </el-form-item>
            <el-form-item label="登录IP白名单：">
                <el-input
                    type="textarea"
                    :rows="4"
                    placeholder="设置允许登录后台系统的ip范围，每行代表一组范围, 如留空不限制登录ip"
                    v-model="loginIPLimitValue"
                >
                </el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit">保存配置</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import { getEnvironment, putHost, getSetting, putSetting } from '../../../api/main/api-host'
export default {
    data() {
        return {
            env: {},
            form: {
                cors: {
                    origins: '',
                    methods: '',
                    headers: '',
                    exposedHeaders: ''
                },
                user: {
                    passwordLifetime: 60,
                    loginErrorLimit: 5,
                    loginErrorTime: 15,
                    loginIPLimit: []
                }
            },
            loginIPLimitValue: ''
        }
    },
    created() {
        getEnvironment().then(res => {
            if (res.code === 0) {
                this.env = res.data
            }
        })
        getSetting().then(res => {
            if (res.code === 0) {
                this.form = res.data
                this.loginIPLimitValue = (this.form.user.loginIPLimit || []).join('\n')
            } else {
                console.log(res.msg)
            }
        })
    },
    methods: {
        onSubmit() {
            let arr = this.loginIPLimitValue.trim().split('\n')
            let ipLimitArr = []
            arr.forEach(e => {
                var item = e.replace(/\s+/g, '')
                if (item !== '') {
                    ipLimitArr.push(item)
                }
            })
            this.form.user.loginIPLimit = ipLimitArr
            putSetting(this.form)
                .then(res => {
                    if (res.code === 0) {
                        this.$message.success(res.msg)
                    } else {
                        this.$message.error(res.msg)
                    }
                })
                .then(() => {
                    putHost().then(() => {})
                })
        }
    }
}
</script>
<style lang="less">
.control-box {
    height: 100%;
    padding: 0 10px;
    overflow: auto;
}
.el-divider {
    margin: 30px 0px;
    .el-divider__text {
        color: #1f8fff;
        font-weight: bold;
    }
}
.el-form {
    * {
        font-size: 13px;
    }
    label.label-red {
        color: #ff9e00;
    }
    padding-right: 30px;
    .base-info .el-form-item {
        margin-bottom: 0px;
        line-height: 25px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/main/control/control.vue